/**
 * main.js
 * @description Module assignment
 */

import $ from 'jquery';
import './app/WindowEvents';
import './app/Slideshow';
import './app/SocialSharing';
import './app/MagnificPopup';
import './app/Spinners';
import './app/Modal';
import './app/MobileMenu';
import './app/PopulateRoomId';
import BookingForm from './app/BookingForm';
import ImageLoading from './app/ImageLoading';
import initRows from './app/Row';
import 'focus-visible'

var Instafeed = require("instafeed.js");
var feed = new Instafeed({
    get: 'user',
    userId: '228339211',
    limit: 3,
    width: 120,
    heigth: 120,
    clientId: '122fef89f34a4bf18d6b3aa72d0ea405',
    accessToken: '228339211.1677ed0.007069328f564c108f3479821128e877',
    template: `<div class="instagram-img">
            <figure class="one-to-one" >
                <a href="{{link}}" target="_blank" class="inner">
                    <div class="bg-thumb" style="background-image: url('{{image}}')"></div>
                </a>
            </figure> 
        </div>`
});

document.addEventListener("DOMContentLoaded", function (event) {
    feed.run();
    new ImageLoading();
    initRows('[data-animate-row]');

    if ( $('booking-form').length ) {
        new BookingForm();
    }

    $('div[aria-describedby], a.learn-more, figure a').removeAttr('aria-describedby tabindex');
    $('.flatpickr-monthDropdown-months').attr('aria-label', 'Select Month');
})

// Header logo scroll animation.
$(document).ready(function () {
    window.isMobile = !!(window.innerWidth < 1000);
    var w = 'left'
    var text = document.getElementsByClassName('hvt-logo-text');
    var line = document.getElementsByClassName('hvt-logo-boxes');
    var svg = document.getElementById('Layer_1');
    var pageWrapper = document.querySelector('.page-wrapper');
    var primaryNav = document.getElementsByClassName('desktop-nav')[0];

    var marginHeight = 60;
    var activeMarginHeight = marginHeight;
    var maxDesktopHeight = 160;
    var maxMobileHeight = 140;
    var maxHeight = maxDesktopHeight;
    var basePadding = 10;
    var adjustmentFactor = .96;
    var minHeight = 40;

    var navWidth;
    var maxWidth;
    var newLeft = 'auto';
    var newRight = 'auto';
    var offsetY = 0;
    var ratio = 6; // 119 : 20 ~= 6 : 1
    var ticking = false;

    function update() {
        ticking = false;
        var newHeight = Math.max(0, maxHeight - offsetY);

        if (newHeight <= minHeight) {
            primaryNav.classList.add('shrink');
        } else {
            primaryNav.classList.remove('shrink');
        }

        svg.style.height = newHeight + 'px';

        // Investigate whether this is really an issue outside of dev, fixes insane chrome render issue ~ colin
        svg.style.opacity = '.99';
        setTimeout(function () {
            svg.style.opacity = '1';
        }, 0);

        pageWrapper.style.paddingTop = $(primaryNav).outerHeight() + 'px';

    }

    function setup() {
        // Set size specific values and adjustments
        if (window.isMobile) {
            navWidth = window.innerWidth - 30;
            maxHeight = maxMobileHeight;
            activeMarginHeight = 0;
            adjustmentFactor = .97;

        } else {
            maxHeight = maxDesktopHeight;
            activeMarginHeight = marginHeight;
            adjustmentFactor = .96;
        }

        basePadding = navWidth / 100;
        offsetY = window.scrollY;
        maxWidth = navWidth;

        update();

        svg.style.display = 'block';
    }

    function onScroll() {
        offsetY = window.scrollY;
        requestTick();
    }

    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(update);
        }

        ticking = true;
    }

    $(window).resize(function () {
        setup();
    });

    window.addEventListener('scroll', onScroll, false);
    setup();
});
